<template>
  <el-table :data="demoTableData" border style="width: 100%">
    <template v-for="(item, index) in configTable" >
        <el-table-column :prop="item.prop" :label="item.label" :key="index" align="center"> </el-table-column>
    </template>
  </el-table>
</template>
   
<script>
export default {
  data() {
    return {};
  },
  props:{
    // 表头配置
    configTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //tbody内容
    demoTableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },    
  created() {},
  methods: {},
};
</script>
   
<style  lang='scss'>
/* 表格样式 start */
.el-table th.el-table__cell {
  background-color: #00a7ab;
  color: #fff;
  font-size: 16px;
}
.el-table--group,
.el-table--border {
  border: 1px solid #00a7ab;
}
.el-table th.el-table__cell.is-leaf,
.el-table td.el-table__cell {
  border-bottom: 1px solid #44bfc2;
}
.el-table--border .el-table__cell {
  border-right: 1px solid #44bfc2;
  font-size: 16px;
}
/* 表格样式 end */
</style>